<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15q0vIi/tc-custom/9781488002144.jpg?1724862818594" alt="This image is the cover for the book Rich Rancher for Christmas, The Beaumont Heirs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rich Rancher for Christmas, The Beaumont Heirs
      </h1>
      <p class="bookDescription body article font2">
        <b>In this sexy holiday romance, a celebrity journalist is snowbound with a cowboy she is trying to prove is the illegitimate son of a billionaire patriarch.</b><br/><br/>CJ Wesley values his privacy more than anything. If TV news star Natalie Baker reveals he’s really a Beaumont heir, the media will go wild. That’s when a surprise snowstorm strands the beautiful reporter in his house—and in his bed. Soon he’ll learn how much she’s discovered . . . and how much he wants her. <br/><br/>CJ defies Natalie’s expectations. The gruff, sexy cowboy knows how to heat up a snowbound cabin and make Christmas magical. Exposing the elusive Beaumont brother will save her job—but only at the price of their passionate connection. It’s a holiday dilemma . . . but will the right choice lead to forever?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah M. Anderson
      </h2>
      
      <p class="authorDescription body article">Sarah M. Anderson won RT Reviewer&#39;s Choice 2012 Desire of the Year for <I>A Man of Privilege</I>. <I>The Nanny Plan</I> was a 2016 RITA&reg; winner for Contemporary Romance: Short.&#160;Find out more about Sarah&#39;s love of cowboys at www.sarahmanderson.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c067b82